import { render, staticRenderFns } from "./GSolicitud.vue?vue&type=template&id=e0391cb0"
import script from "./GSolicitud.vue?vue&type=script&lang=js"
export * from "./GSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports